const AllAppraisalGroup = () =>
  import("./views/appraisal-group/AllAppraisalGroup.vue");
const CreateAppraisalGroup = () =>
  import("./views/appraisal-group/CreateAppraisalGroup.vue");
const ViewAppraisalGroup = () =>
  import("./views/appraisal-group/ViewAppraisalGroup.vue");
const AppraisalGroupArchive = () =>
  import("./views/appraisal-group/AppraisalGroupArchive.vue");

const AllMyAppraisal = () => import("./views/my-appraisal/AllMyAppraisal.vue");
const ViewAppraisal = () => import("./views/ViewAppraisal.vue");

const AppraisalHistoryTable = () => import("./views/AppraisalHistoryTable.vue");
const ViewAppraisalHistory = () => import("./views/ViewAppraisalHistory.vue");

const AllAppraisalApproval = () =>
  import("./views/approval/AllAppraisalApproval.vue");
const ViewAppraisalApproval = () =>
  import("./views/approval/ViewAppraisalApproval.vue");

const Settings = () => import("./views/Settings.vue");
const CreateGeneralSettings = () =>
  import("./views/settings/general/CreateGeneralSettings.vue");
const EditGeneralSettings = () =>
  import("./views/settings/general/EditGeneralSettings.vue");
const ViewGeneralSettings = () =>
  import("./views/settings/general/SettingsViewGeneralAppraisal.vue");

const GradeSettings = () => import("./views/settings/grades/GradeSettings.vue");
const CreateGradeSettings = () =>
  import("./views/settings/grades/CreateGradeSettings.vue");
const EditGradeSettings = () =>
  import("./views/settings/grades/EditGradeSettings.vue");
const ViewGradeSettings = () =>
  import("./views/settings/grades/ViewGradeSettings.vue");

const SettingsAllAppraisal = () =>
  import("./views/settings/appraisals/SettingsAllAppraisal.vue");
const SettingsViewAppraisal = () =>
  import("./views/settings/appraisals/SettingsViewAppraisal.vue");
const SettingsCreateAppraisal = () =>
  import("./views/settings/appraisals/SettingsCreateAppraisal.vue");

const AllApprovers = () =>
  import("@/components/general/approvals/AllApprovers.vue");
const AssignEmployeesAsApprovers = () =>
  import("@/components/general/approvals/AssignEmployeeToApprover.vue");
const ViewApprovers = () =>
  import("@/components/general/approvals/ViewApprovers.vue");
const CreateApprover = () =>
  import("@/components/general/approvals/CreateApprovers.vue");

import approverProps from "@/components/general/approvals/ApproverProps.js";
const { performanceAppraisal } = approverProps;

export default [
  {
    path: "appraisal-group",
    component: AllAppraisalGroup,
  },
  {
    path: "create-appraisal-group",
    component: CreateAppraisalGroup,
  },
  {
    path: "appraisal-group/view/:id",
    component: ViewAppraisalGroup,
  },
  {
    path: "appraisal-group/archive",
    component: AppraisalGroupArchive,
  },
  {
    path: "my-appraisal",
    component: AllMyAppraisal,
  },
  {
    path: "view-appraisal/:id",
    component: ViewAppraisal,
  },
  {
    path: "appraisal-history",
    component: AppraisalHistoryTable,
  },
  {
    path: "view-appraisal-history",
    component: ViewAppraisalHistory,
  },
  {
    path: "appraisal-approvals",
    component: AllAppraisalApproval,
  },
  {
    path: "view-appraisal-approval",
    component: ViewAppraisalApproval,
  },
  {
    path: "settings",
    component: Settings,
  },
  {
    path: "settings-general",
    component: ViewGeneralSettings,
  },
  {
    path: "settings-general/create",
    component: CreateGeneralSettings,
  },
  {
    path: "settings-general/edit",
    component: EditGeneralSettings,
  },
  {
    path: "settings-general/view/:id",
    component: ViewGeneralSettings,
  },
  {
    path: "settings-grades",
    component: GradeSettings,
  },
  {
    path: "settings-grades/create",
    component: CreateGradeSettings,
  },
  {
    path: "settings-grades/view/:id",
    component: ViewGradeSettings,
  },
  {
    path: "settings-grades/edit",
    component: EditGradeSettings,
  },

  {
    path: "settings/appraisal",
    component: SettingsAllAppraisal,
  },
  {
    path: "settings/appraisal/view/:id",
    component: SettingsViewAppraisal,
  },
  {
    path: "settings/appraisal/create",
    component: SettingsCreateAppraisal,
  },
  {
    path: "settings/appraisal/edit/:id",
    component: SettingsCreateAppraisal,
  },
  {
    path: "settings/appraisal/assign/:id",
    component: AssignEmployeesAsApprovers,
  },
  {
    path: "settings/approvers",
    component: AllApprovers,
    props: performanceAppraisal,
  },
  {
    path: "settings/approvers/assign/:id",
    component: AssignEmployeesAsApprovers,
    props: performanceAppraisal,
  },
  {
    path: "settings/approvers/edit/:id",
    component: CreateApprover,
    props: performanceAppraisal,
  },
  {
    path: "settings/approvers/view/:id",
    component: ViewApprovers,
    props: performanceAppraisal,
  },
  {
    path: "settings/approvers/create",
    component: CreateApprover,
    props: performanceAppraisal,
  },
];
